import _ from 'underscore';

import Config from '../../../config';
import Model from '../../../model/model';
import Form from '../../form';





let Filters; export default Filters = Form.extend( {

    events: {
        'click .-clear-filters'() {
            this.clear();
        },
    },

    onBind(filtersModel) {
        listen.call( this );
    },

    // todo onUnBind

    clear() {
        const {
            done_checkbox, working_checkbox,
            planned_checkbox, fail_checkbox,
            // off_checkbox,
            ...defaultFilters,
        } = this.constructor.defaultFilterValues();

        this.stopListening( this.model );
        this.model.set( defaultFilters );
        listen.call( this );
        
        // notify listeners that filters have been cleared
        this.trigger( 'change', this.model.values() );
    },

    serialize(context) {
        const 
            { showScheduleFilters, ...otherProps } = context;

        return {
            showScheduleFilters: undefined !== showScheduleFilters ? showScheduleFilters : true,
            types: this.options.types.toJSON().filter( type =>
                type.role_ids == null ||
                type.role_ids.includes( Config.role() ) ||
                type.role_ids.includes( +Config.role() ) ),
            ...otherProps,
        }
    }
}, {

    Model: Model.extend( {

        constructor(options = {}, ...args) {
            if (options.time)
                options = {
                    ...options,
                    taskTitle: options.time,
                    time: undefined,
                };

            Model.apply( this, [options, ...args] );
        },

        computeds: {
    
            user: {
                set(value) {
                    if (!value)
                        return {
                            assignedUserId: undefined,
                            assignedUserName: '',
                        };
    
                    const {id, name} = value;
    
                    return {
                        assignedUserId: id === 0 ? undefined : id,
                        assignedUserName: name,
                    };
                },
    
                get() {
                    const id = this.get( 'assignedUserId' );
                    const fio = this.get( 'assignedUserName' );
    
                    return !!id
                        ? { id, name: fio, }
                        : null;
                },
            },
    
            assignedOrganization: {
                set(value) {
                    if (!value) 
                        return {
                            assignedOrganizationId: 0,
                            assignedUserId: undefined,
                            assignedUserName: '',
                        };
    
                    return {
                        assignedOrganizationId: +value,
                        assignedUserId: undefined,
                        assignedUserName: '',
                    };
                },
    
                get() {
                    return this.get( 'assignedOrganizationId' );
                }
            },
            
            changedAttrsCount: {
                deps: ['scheduleTitle', 'taskTitle', 'typeId', 'priorityId', 'assignedOrganizationId', 'assignedUserId', 'assignedUserName', 'contractId', 'organizationId'],
                get() {
                    const filters = {
                        ...Filters.defaultFilterValues(),
                        done_checkbox: this.get( 'done_checkbox' ),
                        working_checkbox: this.get( 'working_checkbox' ),
                        planned_checkbox: this.get( 'planned_checkbox' ),
                        fail_checkbox: this.get( 'fail_checkbox' ),
                        // off_checkbox: this.get( 'off_checkbox' ),
                    };

                    return this.diff( filters ).length || '';
                }
            },
    
            changed: {
                deps: ['changedAttrsCount'],
                get() {
                    return this.get( 'changedAttrsCount' );
                }
            },

            doneDisabled: {
                deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox'/*, 'off_checkbox'*/],
                get() {
                    return this.get( 'done_checkbox' )
                        && !this.get( 'working_checkbox' )
                        && !this.get( 'planned_checkbox' )
                        && !this.get( 'fail_checkbox' )
                        // && !this.get( 'off_checkbox' );
                }
            },
            
            workingDisabled: {
                deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox'/* , 'off_checkbox'*/],
                get() {
                    return !this.get( 'done_checkbox' )
                        && this.get( 'working_checkbox' )
                        && !this.get( 'planned_checkbox' )
                        && !this.get( 'fail_checkbox' )
                        // && !this.get( 'off_checkbox' );
                }
            },
            
            plannedDisabled: {
                deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox'/*, 'off_checkbox'*/],
                get() {
                    return !this.get( 'done_checkbox' )
                        && !this.get( 'working_checkbox' )
                        && this.get( 'planned_checkbox' )
                        && !this.get( 'fail_checkbox' )
                        // && !this.get( 'off_checkbox' );
                }
            },
            
            failDisabled: {
                deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox'/*, 'off_checkbox'*/],
                get() {
                    return !this.get( 'done_checkbox' )
                        && !this.get( 'working_checkbox' )
                        && !this.get( 'planned_checkbox' )
                        && this.get( 'fail_checkbox' )
                        // && !this.get( 'off_checkbox' );
                }
            },
            
            // offDisabled: {
            //     deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox'/*, 'off_checkbox'*/],
            //     get() {
            //         return !this.get( 'done_checkbox' )
            //             && !this.get( 'working_checkbox' )
            //             && !this.get( 'planned_checkbox' )
            //             && !this.get( 'fail_checkbox' )
            //             // && this.get( 'off_checkbox' );
            //     }
            // },
            
        },

        values() {
            const
                filters = { ...this.toJSON() },
                { taskTitle, } = filters;
    
            let statuses = [];
            if (filters.done_checkbox)
                statuses = ['done_expired', 'done_not_expired'];
            if (filters.working_checkbox)
                statuses = [...statuses, 'working_expired', 'working_not_expired'];
            if (filters.planned_checkbox)
                statuses = [...statuses, 'planned', 'creating'];
            if (filters.fail_checkbox)
                statuses = [...statuses, 'fail', 'missed'];
            // if (filters.off_checkbox)
            //     statuses = [...statuses, 'off'];

            if (statuses.length)
                filters.status = statuses.toString();
    
            const
                match = /^([1-9]|[0-1][0-9]|2[0-3])[ :]([0-5][0-9])/.exec( taskTitle );
    
            if (match) {
                const [, hours, minutes] = match;
                
                filters.time = `${hours.length === 1 ? 0 : ''}${hours}:${minutes}`;
                filters.taskTitle = '';
            }
    
            const digitsOnly = /^[0-9]+$/.exec( filters.scheduleTitle );
            const scheduleTitle = digitsOnly ? '' : filters.scheduleTitle;
            const scheduleSearch = digitsOnly ? filters.scheduleTitle : '';
    
            const pairs = { ...filters, scheduleTitle, scheduleSearch, };
            return Object.keys( pairs )
                // skip nulls - will break IntegerList filters on server
                .filter( key => pairs[key] !== null )
                .map( key => [key, pairs[key]] )
                .reduce( (values, [key, value]) => (values[key] = value, values), {} );
        },
    
    } ),

    defaultFilterValues() {
        return {
            scheduleTitle: '',
            taskTitle: '',
            typeId: null,
            priorityId: '',
            contractId: null,
            organizationId: null,
            assignedOrganizationId: 0,
            assignedUserId: undefined,
            assignedUserName: '',
            planned_checkbox: true,
            done_checkbox: true,
            working_checkbox: true,
            fail_checkbox: true,
            // off_checkbox: false,
        };
    },

} );

function listen() {
    const 
        trigger = () => this.trigger( 'change', this.model.toJSON() ),
        debounceTrigger = _.debounce( trigger, 350 ),
        shortDebounceTrigger = _.debounce( trigger, 100 );
    
    this.listenTo( this.model, 'change:contractId', shortDebounceTrigger );
    this.listenTo( this.model, 'change:organizationId', shortDebounceTrigger );
    this.listenTo( this.model, 'change:typeId', shortDebounceTrigger );
    this.listenTo( this.model, 'change:priorityId', shortDebounceTrigger );
    this.listenTo( this.model, 'change:user', shortDebounceTrigger );
    this.listenTo( this.model, 'change:assignedOrganization', shortDebounceTrigger );
    this.listenTo( this.model, 'change:taskTitle', debounceTrigger );
    this.listenTo( this.model, 'change:scheduleTitle', debounceTrigger );
    this.listenTo( this.model, 'change:done_checkbox', debounceTrigger );
    this.listenTo( this.model, 'change:working_checkbox', debounceTrigger );
    this.listenTo( this.model, 'change:planned_checkbox', debounceTrigger );
    this.listenTo( this.model, 'change:fail_checkbox', debounceTrigger );
    // this.listenTo( this.model, 'change:off_checkbox', debounceTrigger );
}


// WEBPACK FOOTER //
// ./src/js/view/module/schedule/launch.filters.js